import axios from "axios";
import SETTINGS from '../settings';
import router from "@/router";
import store from "@/store";

const baseURL = SETTINGS.API_BASE_PATH === '/api' ? '' : SETTINGS.API_BASE_PATH
const ajax = axios.create({
    baseURL: baseURL
})

ajax.CancelToken = axios.CancelToken
ajax.isCancel = axios.isCancel

let isHandlingAuthRedirect = false

function getVuexStorage() {
    try {
        return JSON.parse(localStorage.getItem('vuex')) || {}
    } catch (e) {
        return {}
    }
}

function getRouteValue() {
    if (!router.currentRoute) {
        return null
    }

    // Vue Router 4 exposes currentRoute as a ref, Vue Router 3 exposes plain object.
    return router.currentRoute.value || router.currentRoute
}

function getCompanySlugFromRoute() {
    const route = getRouteValue()

    if (route && route.params && route.params.companySlug) {
        return route.params.companySlug
    }

    const path = (route && route.path) || window.location.pathname || ''
    const segment = path.split('/').filter(Boolean)[0]

    if (!segment) {
        return null
    }

    const nonCompanyRoutes = ['login', 'authenticate', 'company-select']
    return nonCompanyRoutes.includes(segment) ? null : segment
}

function buildOpenCapgeminiSsoUrl(idCompany) {
    const redirectUri = encodeURIComponent('https://engage.edge.capgemini.com/authenticate')
    return `https://signin.capgemini.com/as/authorization.oauth2?response_type=code&client_id=capgeminiengage&redirect_uri=${redirectUri}&state=opencapgeministage-${idCompany}&scope=openid`
}

async function getOpenCapgeminiCompany(companySlug) {
    const candidates = [companySlug]
    const dottedSlug = companySlug.replaceAll('-', '.')

    if (dottedSlug !== companySlug) {
        candidates.push(dottedSlug)
    }

    for (const slugCandidate of candidates) {
        try {
            const response = await axios.get(`${SETTINGS.API_BASE_PATH}/checkcompanyisopencapgemini/${slugCandidate}`)
            return response.data
        } catch (e) {
            if (!e || !e.response || e.response.status !== 404) {
                throw e
            }
        }
    }

    return null
}

async function handleAuthLossRedirect() {
    if (isHandlingAuthRedirect) {
        return
    }

    isHandlingAuthRedirect = true;
    store.dispatch('setToken', null);
    localStorage.removeItem('vuex');
    localStorage.clear();

    try {
        const companySlug = getCompanySlugFromRoute();

        if (companySlug) {
            const companyData = await getOpenCapgeminiCompany(companySlug)
            if (companyData && companyData.isCapgeminiOpenAccess && companyData.idCompany) {
                window.location.href = buildOpenCapgeminiSsoUrl(companyData.idCompany)
                return
            }
        }
    } catch (e) {
        // Fallback to login when company lookup fails.
    }

    isHandlingAuthRedirect = false
    router.push('/login').catch(() => {})
}

/*
 * The interceptor here ensures that we check for the token in local storage every time an ajax request is made
 */
ajax.interceptors.request.use(
    async (config) => {
        const storage = getVuexStorage()

        if (storage.user && storage.user.expiryDate && storage.user.expiryDate - new Date().getTime() < 0) {
            await handleAuthLossRedirect()
            return Promise.reject(new axios.Cancel('Session expired'))
        }

        // if(storage.user.expiryDate - new Date().getTime() < 300000) {
        //     storage.user.expiryDate = new Date().getTime() + 0.25 * 3600 * 1000 //15 minutes
        //     localStorage.setItem('vuex', JSON.stringify(storage))
        // }
        if (storage.user && storage.user.token) {
            config.headers['Authorization'] = `Bearer ${ storage.user.token }`
        }

        return config
    },


    (error) => {
        return Promise.reject(error)
    }
)

ajax.interceptors.response.use(function (response) {
    return response
}, async function (error) {
  console.log(error)
    if (error && error.response && error.response.status === 401) {
        await handleAuthLossRedirect()
    }
    return Promise.reject(error)
})

export default ajax